import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Preview = ({ res }) => (
  <div className="max-h-64 space-y-3 overflow-y-auto rounded-card border border-line p-3 text-sm" data-testid="bw-preview" data-user-content="">
    <p className="font-semibold text-ink" data-testid="bw-count">{res.to_import.length} voci da importare</p>
    <ul className="space-y-0.5 text-slate-600">{res.to_import.map((e, i) => <li key={i} className="truncate">{e.title}{e.username && <span className="text-slate-400"> · {e.username}</span>}</li>)}</ul>
    {res.skipped.length > 0 && (
      <div data-testid="bw-skipped">
        <p className="font-semibold text-slate-500">{res.skipped.length} saltate</p>
        <ul className="text-xs text-slate-500">{res.skipped.map((s, i) => <li key={i} className="truncate">{s.title} — {s.reason}</li>)}</ul>
      </div>
    )}
  </div>
);

export const BitwardenImportDialog = ({ open, onOpenChange, onDone }) => {
  const [file, setFile] = useState(null), [encrypted, setEncrypted] = useState(false), [password, setPassword] = useState("");
  const [res, setRes] = useState(null), [busy, setBusy] = useState(false);
  const reset = () => { setFile(null); setEncrypted(false); setPassword(""); setRes(null); };
  const pick = async (f) => {
    setRes(null);
    if (!f) { setFile(null); return; }
    const text = await f.text();
    try { setEncrypted(!!JSON.parse(text).encrypted); setFile(text); } catch { toast.error("Il file non è un JSON valido."); setFile(null); }
  };
  const run = async (confirm) => {
    setBusy(true);
    try {
      const { data } = await api.post("/vault/import/bitwarden", { file, password: password || null, confirm });
      if (!confirm) { setRes(data); return; }
      toast.success(`${data.imported} voci importate`);
      reset(); onOpenChange(false); onDone();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  const close = (o) => { if (!o) reset(); onOpenChange(o); };
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-lg" data-testid="bw-import-dialog">
        <DialogHeader>
          <DialogTitle>Importa da Bitwarden</DialogTitle>
          <DialogDescription>Esporta da Bitwarden in formato .json (non cifrato o «Protetto da password»). Le voci saranno visibili solo a te finché non le condividi. Il file non viene salvato.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input type="file" accept=".json,application/json" onChange={(e) => pick(e.target.files?.[0])} data-testid="bw-file-input" />
          {encrypted && <Input type="password" autoComplete="off" placeholder="Password di esportazione" value={password}
            onChange={(e) => { setPassword(e.target.value); setRes(null); }} data-testid="bw-password-input" />}
          {res && <Preview res={res} />}
        </div>
        <DialogFooter>
          {!res ? (
            <Button onClick={() => run(false)} disabled={!file || busy || (encrypted && !password)} data-testid="bw-preview-btn">{busy ? "Lettura…" : "Anteprima"}</Button>
          ) : (
            <Button onClick={() => run(true)} disabled={busy || !res.to_import.length} data-testid="bw-confirm-btn">{busy ? "Importazione…" : `Importa ${res.to_import.length} voci`}</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
